import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLoginSlice } from '../slice';
import { Button } from 'app/components/ui/button';
import { useToast } from 'app/components/ui/use-toast';

export const ConfirmEmailChange = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const { useConfirmPasswordResetMutation } = useLoginSlice();
  const [confirmPasswordReset, { isLoading, isError, isSuccess, error, data }] =
    useConfirmPasswordResetMutation();
  const called = useRef(false);

  useEffect(() => {
    if (!called.current && token) {
      confirmPasswordReset({ token });
      called.current = true;
    }
  }, [token, confirmPasswordReset]);

  useEffect(() => {
    if (data) {
      toast({
        variant: 'success',
        description: data.message,
      });
      navigate('/login');
    }
  }, [isError, error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[300px] p-8">
      {isLoading && <p className="text-gray-600">Processing your request...</p>}
      {isSuccess && (
        <div className="text-green-600 text-center">
          <p>{data?.message || 'Your email has been successfully changed.'}</p>
          <Button className="mt-4" asChild>
            <a href="/login">Go to Login</a>
          </Button>
        </div>
      )}
      {isError && (
        <div className="text-red-600 text-center">
          <p>
            {(error as any)?.data?.error || 'Failed to confirm email change.'}
          </p>
          <Button className="mt-4" asChild>
            <a href="/login">Go to Login</a>
          </Button>
        </div>
      )}
    </div>
  );
};
